import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import AdvisorCard from './AdvisorCard';

const SkeletonCard = () => (
  <div className="bg-white rounded-xl border border-gray-200 p-4">
    <div className="flex items-start gap-3 mb-4">
      <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse" />
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse" />
        <div className="h-3 bg-gray-100 rounded w-1/2 animate-pulse" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-3">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="p-2 rounded-lg bg-gray-50">
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse" />
          <div className="h-4 bg-gray-200 rounded w-1/3 animate-pulse" />
        </div>
      ))}
    </div>
  </div>
);

const MarketplaceFeed = ({ users, loading, error, hasMore, onLoadMore }) => {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!hasMore || !sentinelRef.current) return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) onLoadMore();
    }, { rootMargin: '400px' });
    io.observe(sentinelRef.current);
    return () => io.disconnect();
  }, [hasMore, onLoadMore]);

  if (error) {
    return (
      <div className="p-4 text-red-700 bg-red-50 border border-red-200 rounded">Failed to load feed.</div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {loading && !users?.length
          ? Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)
          : users.map((u) => <AdvisorCard key={u.id} user={u} />)}
      </div>

      {hasMore && (
        <div ref={sentinelRef} className="h-10" />
      )}
      {!loading && !users?.length && (
        <div className="p-4 border rounded text-gray-600">No advisors found nearby.</div>
      )}
    </div>
  );
};

MarketplaceFeed.propTypes = {
  users: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.any,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
};

export default MarketplaceFeed;


